import { render, staticRenderFns } from "./MacroscopicList.vue?vue&type=template&id=6b8d9a73&scoped=true"
import script from "./MacroscopicList.vue?vue&type=script&lang=js"
export * from "./MacroscopicList.vue?vue&type=script&lang=js"
import style0 from "./MacroscopicList.vue?vue&type=style&index=0&id=6b8d9a73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d9a73",
  null
  
)

export default component.exports